/**
 * Chat interno: agente com agente, agente com o setor.
 *
 * Fica fora do modulo `atendimento` de proposito. Conversa com o contato e
 * conversa de bastidor sao coisas diferentes -- misturar as duas na mesma tela
 * e o caminho mais curto para mandar para o cliente o que era para o colega.
 */
export const nav = {
    permissao: 'atendimento.inbox:ver',
    section: 'Atendimento',
    title: 'ChatInterno',
    icon: 'chat',
    route: '/chat-interno',
    sequence: 2,
};

export default [
    {
        path: '/chat-interno',
        name: 'chat-interno',
        component: () => import('./pages/ChatInternoPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.inbox:ver' },
    },
];
